import React from 'react';
import { useTheme, useMediaQuery } from '@ublend-npm/aulaui-core';
import Dialog from '@mui/material/Dialog';

export interface ResponsiveModalPageSwitcherProps {
  isOpen: boolean;
  onClose?: () => void;
  modalComponent: React.ReactNode;
  pageComponent: React.ReactNode;
}

/**
 * A generic wrapper that conditionally renders either a Modal component (on desktop)
 * or a Page component (on mobile) based on the screen size, without adding any
 * additional wrapper styling of its own.
 */
const ResponsiveModalPageSwitcher: React.FC<
  ResponsiveModalPageSwitcherProps
> = ({ isOpen, onClose, modalComponent, pageComponent }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!isOpen) {
    return null;
  }

  if (isMobile) {
    return (
      <Dialog
        fullScreen
        open={isOpen}
        onClose={onClose}
        PaperProps={{ sx: { bgcolor: 'background.default' } }}
      >
        {pageComponent}
      </Dialog>
    );
  }

  return <>{modalComponent}</>;
};

export default ResponsiveModalPageSwitcher;
